var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-left-top"},[_c('Header',{attrs:{"title":"专利转化价值分布"}}),_c('div',{ref:"echarts",staticClass:"ecahrtBlock"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }